import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from './en';
import { he } from './he';
import { I18nString } from "./types";

const LANGUAGE_STORAGE_KEY = "LM_LANGUAGE";

export const initTranslation = (lng = 'en') => {
  const savedLanguage = getLanguage();
  const language = savedLanguage || lng;
  i18n
  .use(initReactI18next)
  .init({
    resources: { en, he },
    lng: language,
    fallbackLng: language,
    interpolation: {
      escapeValue: false
    },
    parseMissingKeyHandler: (key: string, test: any) => {
      throw new Error(`Translation is missing for the key ${key}`);
    }
  });
}

export const saveLanguage = (language: string) => {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
}

export const getLanguage = () => {
  return localStorage.getItem(LANGUAGE_STORAGE_KEY);
}

export const getTranslation = (property: I18nString) => {
  if (i18n.language === 'de_DE') {
    return property.de_DE;
  }
  if (i18n.language === 'he_IL') {
    return property.he_IL;
  }
  return property.en_US;
}

export const setTranslation = (value: string): I18nString => {
  if (i18n.language === 'de_DE') {
    return { de_DE: value };
  }
  if (i18n.language === 'he_IL') {
    return { he_IL: value };
  }
  return { en_US: value };
}
